import { HttpInterceptorFn,HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../services/auth/auth.service';
import { catchError, throwError } from 'rxjs';
import { inject } from '@angular/core';

export const JwtInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('auth_token');
  const authService = inject(AuthService);

  // Do not attach a stale Bearer token to credential login — user-service
  // rejects invalid JWTs with 401 even on the public /authenticate endpoint.
  const isCredentialLoginRequest = req.url.includes('/authenticate')
    && !req.url.includes('/auth/token-exchange');

  const isTokenExchangeRequest = req.url.includes('/auth/token-exchange');
  const isPublicAuthRequest = isCredentialLoginRequest || isTokenExchangeRequest;

  // A locally expired token must not be sent. Waiting for the permissions call
  // to 401 used to leave the header up and the page blank.
  if (token && !isPublicAuthRequest && authService.isAccessTokenExpired(token)) {
    authService.handleUnauthorizedResponse();
    return throwError(() => new HttpErrorResponse({
      status: 401,
      statusText: 'Unauthorized',
      url: req.url,
    }));
  }

  if (token && !isCredentialLoginRequest) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        (error.status === 401 || error.status === 440) &&
        !isPublicAuthRequest
      ) {
        authService.handleUnauthorizedResponse();
      }
      return throwError(() => error);
    })
  );
}